var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { validate } from 'uuid';
export function transformResponseToFormState(_a) {
    var system_hostname = _a.system_hostname, system_https_port = _a.system_https_port, system_ssh_port = _a.system_ssh_port, system_external_endpoints = _a.system_external_endpoints;
    var transformedData = {
        hostname: system_hostname.hostname,
        httpsPort: system_https_port.port,
        sshPort: system_ssh_port.port,
        endpoints: system_external_endpoints,
    };
    return transformedData;
}
export function transformFormStateToRequest(formState) {
    var hostname = formState.hostname, httpsPort = formState.httpsPort, sshPort = formState.sshPort, endpoints = formState.endpoints;
    var systemHostname = { hostname: hostname };
    var systemHttpsPort = { port: Math.floor(httpsPort) };
    var systemSshPort = { port: Math.floor(sshPort) };
    var transformedEndpoints = endpoints.map(function (_a) {
        var id = _a.id, endpoint = __rest(_a, ["id"]);
        // Remove auto-generated uuid from new endpoints
        if (validate(id)) {
            return endpoint;
        }
        return __assign({ id: id }, endpoint);
    });
    return {
        system_hostname: systemHostname,
        system_https_port: systemHttpsPort,
        system_ssh_port: systemSshPort,
        system_external_endpoints: transformedEndpoints,
    };
}
